import React, { useState, useEffect } from "react";
import { Anchor } from "antd";
import Slider from "react-slick";
import Map from "./Map";
import { Link as LinkRD } from "react-router-dom";
import "antd/dist/antd.css";
import useFetch from '../../../../commons/useFetch';

function HotelContent({ hotels }) {
  const [targetOffset, setTargetOffset] = useState(undefined);
  
  const { Link } = Anchor;
  const {data : specialties}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/specialties/')
  const key = "AIzaSyAwUUGIMXTOZEX_rtcZj1IyvTOqsA2sts4";
  const { data: ServiceHotels } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/ServiceHotels/');
  const roomUtilities = [
    {
      title: "cả căn phòng trong tay bạn",
      description:
        "Không cần phải nhận hoặc gửi lại chìa khoá tại quầy lễ tân, hãy mở cửa phòng bằng chính điện thoại của bạn",
      image: "/images/hotelsPhone.png",
    },
    {
      title: "Mandala 247 bar",
      description: "24/7 Vui hết thảy tại trái tim cuat Mandala",
      image: "/images/hotels-KS.png",
    },
    {
      title: "Điều khiển cả căn phòng chỉ với 1 cú chạm",
      description:
        "Tùy chỉnh điều hòa, âm thanh, ánh sáng, màu sắc theo tâm trạng",
      image: "/images/hotels-Relax.png",
    },
    {
      title: "Phòng nghỉ lạ",
      description:
        "24/7 Vui hết thảy tại trái tim cuat MandalaPhòng không chỉ là nơi để ngủ mà còn thư giãn có gu.",
      image: "/images/hotels-Room.png",
    },
  ];


  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  useEffect(() => {
        setTargetOffset(window.innerHeight / 3);
  }, []);
  return (
    <div className="container">
      <div className="hotelLocation">
        <div className="title">{hotels.name}</div>
        <div className="hotelLocationRow">
          <div className="address">
            <img className="img-fluid" src="/images/ic_location.png" alt="" />{" "}
            <span>{hotels.address}</span>
          </div>
          <div className="phone">
            <img className="img-fluid" src="/images/ic_phone.png" alt="" />{" "}
            <span>{hotels.phone}</span>
          </div>
        </div>
      </div>
      <div className="introAnchor">
        <Anchor
          targetOffset={targetOffset}
          affix={false}
          className="anchorLists"
        >
          <Link href="#introHotel" title="Giới thiệu" />
          <Link href="#mapHotel" title="Vị trí" />
          <Link href="#roomUtilities" title="Phòng" />
          <Link href="#destinationHotel" title="Điểm đến" />
        </Anchor>
        <div className=" anchorContent" id="introHotel">
          <div className="title">
            <img className="img-fluid" src="/images/logo.png" alt="" /> Giới
            thiệu về khách sạn
          </div>
          <div className="formRow">
            <div className="introText formCol">{hotels.description}</div>
            <div className="introService formCol">
              {ServiceHotels &&
                ServiceHotels.map((item, index) => {
                  return (
                    <div className="serviceItem" key={index}>
                      <img className="img-fluid" src={item.icon} alt="" />
                      <span>{item.name}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="anchorContent" id="mapHotel">
          <div className="title">
            <img className="img-fluid" src="/images/logo.png" alt="" /> vị trí
          </div>
          <div className="map">
            <Map
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={
                <div
                  style={{
                    height: `100%`,
                    margin: `auto`,
                  }}
                />
              }
              hotels={hotels}
              mapElement={<div style={{ height: `100%` }} />}
            />
          </div>
        </div>
        <div className="anchorContent" id="roomUtilities">
          <div className="title">
            <img className="img-fluid" src="/images/logo.png" alt="" /> Phòng và
            các tiện ích
          </div>
          <div className="roomUtilitiesSlide">
            <Slider {...settings}>
              {roomUtilities.map((content) => {
                return (
                  <div className="slideItem">
                    <div className="row">
                      <div className="col-lg-6 col-12 col-md-6 contentBox">
                        <div className="content">
                          <h5 className="titleSlide">{content.title}</h5>
                          <p>{content.description}</p>
                          <div className="linkMore">
                            <LinkRD to="/experiences">
                              Xem thêm
                              <span>
                                <img
                                  className="iconArrow"
                                  src="/images/ic_arrow2.png"
                                  alt=""
                                />
                              </span>
                            </LinkRD>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-12 col-md-6 imgBox">
                        <img classNam="img-fluid" src={content.image} alt="" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
        <div className="anchorContent" id="destinationHotel">
          <div className="title">
            <img className="img-fluid" src="/images/logo.png" alt="" /> ĐIỂM ĐẾN
          </div>
          <div className="row">
            {specialties &&
              specialties.filter(
                (spec) => spec.destination_id === hotels.destination_id
            ).slice(0, 4).map((item) => {
                return (
                  <div className="col-lg-3 col-12 col-md-6">
                    <div className="itemBox">
                      <div className="content">
                        <img className="img-fluid" src={item.image} alt="" />
                        <div className="textContent">
                          Thổ Hà là một trong ba thôn của xã Vân Hà- nơi có
                          không gian văn hoá đậm đặc của toàn vùng Kinh Bắc. Lễ
                          hội Thổ Hà được tổ chức trong 2 ngày 21, 22 tháng
                          giêng âm lịch hàng năm.
                        </div>
                      </div>
                      <div className="title">
                        <LinkRD to={`/destination/${hotels.destination_id}/${item.type_name}`}>
                          Lễ hội Thổ Hà
                        </LinkRD>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="linkMore">
            <LinkRD to={`/destination/${hotels.destination_id}`}>
              Xem thêm
              <span>
                <img className="iconArrow" src="/images/ic_arrow2.png" alt="" />
              </span>
            </LinkRD>
          </div>
        </div>
      </div>
    </div>
  );
}
export default HotelContent;
